import React, { memo, useMemo } from 'react';
import { ControlsRow, TextChip } from 'design-system/controls';
import ToolTip from 'design-system/ToolTip';
import { getDatesChipTitle } from 'features/analytics/components/AnalyticsControls';
const budgetingPeriodToolTip = (<ToolTip title="Period" subtitle="This is the period you have selected when setting up budgeting. All your budgets will sync to this. If you want to change it, just tap on the edit icon on the top right of the screen." small/>);
const BudgetingControls = ({ month, payPeriod }) => {
    const title = useMemo(() => getDatesChipTitle(month, payPeriod), [month, payPeriod]);
    return (<ControlsRow>
      <TextChip text={title} disabled toolTip={budgetingPeriodToolTip}/>
    </ControlsRow>);
};
export default memo(BudgetingControls);
